var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnpinnedMessageIcon = function SvgUnpinnedMessageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "unpinned-message-icon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m1 3 18 18"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 14h5.816a1 1 0 0 0 .877-1.479l-1.385-2.54a10 10 0 0 1-1.085-3.145l-.584-3.5a1 1 0 0 0-.986-.836H8.92a1 1 0 0 0-.996.917l-.249 2.979a10 10 0 0 1-1.186 3.958L5.307 12.52A1 1 0 0 0 6.185 14zm0 0v7.5",
    mask: "url(#unpinned-message-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m3 3 18 18"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnpinnedMessageIcon);
export { ForwardRef as Icon };
export default "customIcons/unpinned-message-icon.75392dc.svg";